module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst showProtocolGranted = helpers.hasAccessTo('cms_protocolActions:read');\nconst requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx');\n%>\n<div class=\"buttons\">\n<div class=\"left\">\n<%\nif(config.usage !== 'selection' && config.usageMode !== 'choose'){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'product', mode: '', symbolOnly: true } }); %><%\n}\n%>\n</div>\n<div class=\"right\">\n<%\nif(config.usage !== 'selection' && config.usageMode !== 'choose'){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showDuplicate', context: 'product', mode: '', symbolOnly: true } }); %><%\nif(showProtocolGranted){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showProtocol', context: 'product', mode: '', symbolOnly: true } }); %><%\n}\nif(requestProductAdditionalInformationGranted){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductAdditionalInformation', context: 'product', mode: '', symbolOnly: true, icon: 'fi fi-robot' } }); %><%\n}\n}\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'openArticleUrl', context: 'product', mode: '', symbolOnly: true, icon: 'fi fi-link' } }); %><%\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'open', context: 'routes', mode: '', symbolOnly: true } }); %><%\n%>\n</div>\n</div>"
  , __filename = "components/templates/mblx/products/table/customColActions.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const showProtocolGranted = helpers.hasAccessTo('cms_protocolActions:read');
const requestProductAdditionalInformationGranted = helpers.hasAccessTo('mblx_productsAdditionalInformation:generate', 'mblx');

    ; __line = 4
    ; __append("\n<div class=\"buttons\">\n<div class=\"left\">\n")
    ; __line = 7
    ; 
if(config.usage !== 'selection' && config.usageMode !== 'choose'){

    ; __line = 9
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'product', mode: '', symbolOnly: true } }) )
    ; 
}

    ; __line = 11
    ; __append("\n</div>\n<div class=\"right\">\n")
    ; __line = 14
    ; 
if(config.usage !== 'selection' && config.usageMode !== 'choose'){

    ; __line = 16
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showDuplicate', context: 'product', mode: '', symbolOnly: true } }) )
    ; 
if(showProtocolGranted){

    ; __line = 18
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showProtocol', context: 'product', mode: '', symbolOnly: true } }) )
    ; 
}
if(requestProductAdditionalInformationGranted){

    ; __line = 21
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'requestProductAdditionalInformation', context: 'product', mode: '', symbolOnly: true, icon: 'fi fi-robot' } }) )
    ; 
}
}

    ; __line = 24
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'openArticleUrl', context: 'product', mode: '', symbolOnly: true, icon: 'fi fi-link' } }) )
    ; 

    ; __line = 25
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'open', context: 'routes', mode: '', symbolOnly: true } }) )
    ; 

    ; __line = 26
    ; __append("\n</div>\n</div>")
    ; __line = 28
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/table/customColActions.ejs

}